var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"positionBanner"}},[_c('div',{staticClass:"position-time"},[_c('real-time')],1),_vm._v(" "),_c('img',{staticClass:"dbbk",attrs:{"src":require("../../../static/temporary_images/btk.png"),"alt":"pic"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cca55be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/positionBanner/positionBanner.vue
// module id = null
// module chunks = 